module.exports = __webpack_public_path__ + "ghost-eyes.ec04b23c7f309218f2e6d87f6525578f.gif";